import { RemoveAdminModal} from "./RemoveAdminModal";

export default RemoveAdminModal;
